@if (basePagedTableComponent?.data) {
  <div class="position-relative">
    <ng-content select="[pre-table]" />

    @if (basePagedTableComponent.data.length > 0) {
      @if (isCustomTable) {
        <ng-content select="[table]" />
      } @else {
        <table class="{{ mode }}">
          <thead>
          <ng-content select="[thead]" />
          </thead>
          <tbody>
          <ng-content select="[tbody]" />
          </tbody>
        </table>
      }

      <div class="m-t-24 d-flex justify-content-center">
        <app-pagination
          [pagination]="basePagedTableComponent?.pagination"
          (pageChange)="basePagedTableComponent?.pagination.page = $event; basePagedTableComponent?.loadData();"
        />
      </div>
    } @else {
      <p class="text-center">
        {{ 'No data found' | trans:'app/tables/no-data-found.Label' }}
      </p>
    }

    @if (basePagedTableComponent?.isLoading()) {
      <app-loader size="lg" [isAbsolute]="true" [showBackground]="true" />
    }
  </div>
} @else if (basePagedTableComponent?.isLoading()) {
  <div class="d-flex justify-content-center full-height align-items-center">
    <app-loader size="lg" />
  </div>
}
